import { createContext, useContext, useState, useEffect } from "react";
import { ReactNode } from "react";
import { useAuth } from "hooks";
import { ISession } from "config/interfaces";

interface ISessionProviderProps {
  children: ReactNode;
}
interface ISessionContextData {
  // user: ISessionState | null;
  loading: boolean;
  user: ISession.User | null;
  signed: boolean;
  onSuccess: boolean;
  signIn(values: LoginProps): void;
  signOut(): void;
  forgetPassword(email: string): Promise<void>;
  setSelectedCustomerId(newId: string | null): void;
  errorMessage: string;
  token: string | null;
  selectedCustomerId: string | null;
  IDMCM: string;
  setIDMCM(idmcm: string): void;
  IDSITE: string;
  setIDSITE(idsite: string): void;
  data: any;
  setData(data: any): void;
}

interface OptionsProps {
  label: string;
  value: string;
}
interface State {
  period: number | null;
  set: string | null;
  installation: string;
  installations: Array<OptionsProps>;
  setsOptions: Array<OptionsProps>;
}

const initialState: State = {
  period: 1,
  set: "",
  installation: "",
  installations: [{ label: "", value: "" }],
  setsOptions: [] as Array<{ label: string; value: string }>,
};

interface LoginProps {
  login: string;
  password: string;
  keep: boolean;
}

export const SessionContext = createContext<ISessionContextData>(
  {} as ISessionContextData
);

export function SessionProvider({
  children,
}: ISessionProviderProps): JSX.Element {
  const {
    user,
    loading,
    token,
    signIn,
    signOut,
    errorMessage,
    forgetPassword,
    onSuccess,
    logout,
    setLogout,
  } = useAuth();
  const [selectedCustomerId, setSelectedCustomerId] = useState<null | string>(
    null
  );
  const [IDMCM, setSelectedIDMCM] = useState(() => {
    const idmcm = localStorage.getItem("adminIDMCM");
    if (idmcm) return idmcm;
    return "";
  });
  const [IDSITE, setSelectedIDSITE] = useState(() => {
    const siteID = localStorage.getItem("adminIDSITE");
    if (siteID) return siteID;
    return "";
  });
  // verificar
  const [data, setData] = useState<State>(() => {
    return {
      ...initialState,
      installation: IDSITE ? IDSITE : "",
      set: IDMCM ? IDMCM : "",
    };
  });

  // useEffect(() => {
  //   setSelectedIDMCM("1056");
  //   setSelectedIDSITE("Easytech");
  // }, []);

  const setIDMCM = (idmcm: string) => {
    localStorage.setItem("adminIDMCM", idmcm);
    setSelectedIDMCM(idmcm);
  };

  const setIDSITE = (IDSITE: string) => {
    localStorage.setItem("adminIDSITE", IDSITE);
    setSelectedIDSITE(IDSITE);
  };

  useEffect(() => {
    if (logout) {
      setIDMCM("");
      setIDSITE("");
      setLogout(false);
    }
  }, [logout]);

  return (
    <SessionContext.Provider
      value={{
        user,
        loading,
        signed: !!token,
        signIn,
        signOut,
        errorMessage,
        token,
        selectedCustomerId,
        setSelectedCustomerId,
        forgetPassword,
        onSuccess,
        setIDMCM,
        IDMCM,
        setIDSITE,
        IDSITE,
        data,
        setData,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
}

export const useSession = () => useContext(SessionContext);
